import React from "react";
import Nav from "./Nav";
const OnboardingNavbar = props => {
  return <Nav {...props} />;
};

export { OnboardingNavbar };
